module.exports = __webpack_public_path__ + "img/plan_black.b77c36ed.svg";